import { useState, useEffect } from '@wordpress/element';
import apiFetch from '@wordpress/api-fetch';
import { renderInputRow } from '../../../utils/renderInputRow';

const SectionCard = ({ icon, title, desc, children }) => (
    <div className="cpiw-card">
        <div className="cpiw-card__header">
            <div className="cpiw-card__header-icon"><span style={{ fontSize: '16px' }}>{icon}</span></div>
            <div>
                <div className="cpiw-card__title">{title}</div>
                {desc && <div className="cpiw-card__desc">{desc}</div>}
            </div>
        </div>
        <div className="cpiw-card__body">{children}</div>
    </div>
);

const GeneralTab = ({ toast }) => {
    const [originalSettings, setOriginalSettings] = useState({});
    const [settings, setSettings]                 = useState({});
    const [loading, setLoading]                   = useState(false);

    useEffect(() => {
        const global = window.CPIW_GLOBAL_OPTIONS || {};
        setSettings(global);
        setOriginalSettings(global);
    }, []);

    const handleSave = () => {
        const changedData = Object.fromEntries(
            Object.entries(settings).filter(([k, v]) => originalSettings[k] !== v)
        );
        if (Object.keys(changedData).length === 0) {
            toast.warning('No changes detected.');
            return;
        }
        setLoading(true);
        apiFetch({ path: `/wp/v2/settings`, method: 'POST', data: changedData })
            .then(() => {
                setLoading(false);
                toast.success('General settings saved successfully!');
                setOriginalSettings(settings);
                window.CPIW_GLOBAL_OPTIONS = { ...settings };
            })
            .catch((err) => {
                console.error(err);
                setLoading(false);
                toast.error('Error saving general settings.');
            });
    };

    const updateSetting = (key, value) => setSettings(prev => ({ ...prev, [key]: value }));

    return (
        <div className="plugin-general-tab">
            {loading && (
                <div className="cpiw-overlay-loader">
                    <div className="cpiw-spinner-wrap">
                        <div className="cpiw-spinner" />
                        <span className="cpiw-spinner-label">Saving changes…</span>
                    </div>
                </div>
            )}

            <SectionCard icon="⚙️" title="General Settings" desc="Core plugin toggles and display options.">
                {renderInputRow('Enable Plugin',                'cpiw_enable',  'checkBox', [], '', settings, updateSetting)}
                {renderInputRow('Show Date in Pincode Box',     'cpiw_dateshow','checkBox', [], '', settings, updateSetting)}
                {renderInputRow('Show Cash on Delivery Option', 'cpiw_codshow', 'checkBox', [], '', settings, updateSetting)}
            </SectionCard>

            <SectionCard icon="💬" title="Popup Settings" desc="Control the pincode check popup behavior.">
                {renderInputRow('Enable Popup', 'cpiw_poupshow', 'checkBox', [], '', settings, updateSetting)}
            </SectionCard>

            <SectionCard icon="🎨" title="Pincode Box Color Settings" desc="Customize the look and feel of your pincode widget.">
                <div className="cpiw-color-group">
                    {renderInputRow('Main Background Color',          'mainbackcolor',           'colorPallete', [], '', settings, updateSetting)}
                    {renderInputRow('Check Availability Color',       'checkavailbilitycolor',   'colorPallete', [], '', settings, updateSetting)}
                    {renderInputRow('Delivery Message Color',         'deliverymsgcolor',        'colorPallete', [], '', settings, updateSetting)}
                    {renderInputRow('Delivery Message Background',    'deliverymsgbackcolor',    'colorPallete', [], '', settings, updateSetting)}
                    {renderInputRow('Button Text Color',              'checkandchangetxtcolor',  'colorPallete', [], '', settings, updateSetting)}
                    {renderInputRow('Button Background Color',        'checkandchangebackcolor', 'colorPallete', [], '', settings, updateSetting)}
                    {renderInputRow('Delivery Date Text Color',       'deliverydatetextcolor',   'colorPallete', [], '', settings, updateSetting)}
                    {renderInputRow('Cash on Delivery Text Color',    'codtextcolor',            'colorPallete', [], '', settings, updateSetting)}
                    {renderInputRow('Popup Background Color',         'popupbackcolor',          'colorPallete', [], '', settings, updateSetting)}
                    {renderInputRow('Popup Text Color',               'popuptextcolor',          'colorPallete', [], '', settings, updateSetting)}
                    {renderInputRow('Submit Button Background Color', 'submitbackcolor',         'colorPallete', [], '', settings, updateSetting)}
                    {renderInputRow('Submit Button Text Color',       'submittextcolor',         'colorPallete', [], '', settings, updateSetting)}
                </div>
            </SectionCard>

            <div className="cpiw-save-bar">
                <p className="cpiw-save-bar__hint">
                    <strong>&#9888; Unsaved changes</strong> — Click Save to apply your settings.
                </p>
                <div className="cpiw-save-bar__actions">
                    <button className="cpiw-btn" onClick={handleSave}>&#10003; Save Changes</button>
                </div>
            </div>
        </div>
    );
};

export default GeneralTab;
